import type { Dependent } from '@/types/auth-base.types';

export const isDependentCpfDuplicate = (
  cpf: string,
  dependents: Dependent[] | undefined,
  excludeDependentId?: string,
): boolean => {
  if (!dependents || dependents.length === 0) {
    return false;
  }

  const cleanCpf = cpf.replace(/\D/g, '');

  return dependents.some(
    (dep) => dep.documentNumber && dep.documentNumber.replace(/\D/g, '') === cleanCpf && dep.id !== excludeDependentId,
  );
};
